<script lang="ts">
  export let current = false
</script>

<li class="breadcrumb-item" aria-current="{current ? 'page' : undefined}">
  <slot />
</li>

<style type="text/scss" lang="scss" scoped>
  .breadcrumb-item {
    &:not(:last-child) {
      @apply flex items-center;

      &::after {
        content: "";
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor'%3E%3Cpath fill-rule='evenodd' d='M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' clip-rule='evenodd' /%3E%3C/svg%3E");
        @apply inline-block w-6 h-6;
        @apply p-px;
        @apply bg-center bg-no-repeat bg-contain;
      }
    }

    &:last-child {
      @apply font-semibold;
    }
  }

  
</style>
